export default __webpack_public_path__ + "media/images/lp/pop-pc-9fca02094cc6fe37d8c34e1c961d3004.jpg";